import { create } from 'zustand';
import { organizationsSlice } from './organizations.slice';
import { TOrganizationsStore } from './types';

export const useOrganizationsStore = create<TOrganizationsStore>((...arg) => ({
  ...organizationsSlice(...arg),
}));
